import serviceTicketPartsAllComponent from './service_ticket_parts.all.component';

let serviceTicketPartsAllModule = angular.module('serviceTicketPartsAll', [])

    .component('serviceTicketPartsAll', serviceTicketPartsAllComponent)

    .name;

export default serviceTicketPartsAllModule;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/all/index.js